var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import objectReduce from 'fast-loops/lib/objectReduce';
import objectEach from 'fast-loops/lib/objectEach';
import { combineMultiRules } from 'fela-tools';
import shallowCompare from 'react-addons-shallow-compare';

import generateDisplayName from './generateDisplayName';
import generateSelectorPrefix from './generateSelectorPrefix';
import hoistStatics from './hoistStatics';

var defaultConfig = {
  pure: true
};

export default function connectFactory(BaseComponent, createElement, withTheme, contextTypes) {
  return function connect(rules) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var connectConfig = _extends({}, defaultConfig, config);

    return function (component) {
      var EnhancedComponent = function (_BaseComponent) {
        _inherits(EnhancedComponent, _BaseComponent);

        function EnhancedComponent() {
          _classCallCheck(this, EnhancedComponent);

          return _possibleConstructorReturn(this, (EnhancedComponent.__proto__ || Object.getPrototypeOf(EnhancedComponent)).apply(this, arguments));
        }

        _createClass(EnhancedComponent, [{
          key: 'shouldComponentUpdate',
          value: function shouldComponentUpdate(nextProps, nextState) {
            if (connectConfig.pure) {
              return shallowCompare(this, nextProps, nextState);
            }
            return true;
          }
        }, {
          key: 'render',
          value: function render() {
            var renderer = this.context.renderer;

            var _props = this.props,
                extend = _props.extend,
                _felaTheme = _props._felaTheme,
                _felaRules = _props._felaRules,
                otherProps = _objectWithoutProperties(_props, ['extend', '_felaTheme', '_felaRules']);

            var allRules = [rules];
            if (_felaRules) {
              allRules.push(_felaRules);
            }
            if (extend) {
              allRules.push(extend);
            }

            var combinedRules = combineMultiRules.apply(undefined, allRules);
            var preparedRules = combinedRules(_extends({}, otherProps, {
              theme: _felaTheme
            }), renderer);

            // improve developer experience with monolithic renderer
            if (process.env.NODE_ENV !== 'production' && renderer.prettySelectors) {
              var componentName = component.displayName || component.name || '';

              objectEach(preparedRules, function (rule, name) {
                rule.selectorPrefix = generateSelectorPrefix(componentName, name);
              });
            }

            if (component._isFelaComponent) {
              return createElement(component, _extends({
                _felaRules: combinedRules
              }, otherProps));
            }

            var styles = objectReduce(preparedRules, function (styleMap, rule, name) {
              styleMap[name] = renderer.renderRule(rule, _extends({}, otherProps, {
                theme: _felaTheme
              }));

              return styleMap;
            }, {});

            var boundRules = objectReduce(preparedRules, function (ruleMap, rule, name) {
              ruleMap[name] = function (props) {
                return rule(_extends({
                  theme: _felaTheme
                }, props), renderer);
              };

              return ruleMap;
            }, {});

            return createElement(component, _extends({}, otherProps, {
              styles: styles,
              rules: boundRules
            }));
          }
        }]);

        return EnhancedComponent;
      }(BaseComponent);

      EnhancedComponent.displayName = generateDisplayName(component);
      EnhancedComponent._isFelaComponent = true;


      if (contextTypes) {
        EnhancedComponent.contextTypes = contextTypes;
      }

      var themedComponent = withTheme(EnhancedComponent, '_felaTheme');
      return hoistStatics(themedComponent, component);
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-bindings/es/connectFactory.js
// module id = 1105
// module chunks = 0